itsoftApp.createModule("navInstruction", ["pageLoad", "windowScroll", "windowResize"], function () {
    const module = this;

    const NavInstruction = function () {
        this.data = {
            names: [],
            blocks: [],
            class: {
                active: '_active',
            },
        }

        this.list = document.querySelector('.js-nav-side');
        this.ul = this.list && this.list.querySelector('ul');
        this.links = this.list && this.list.querySelectorAll('[data-href]');

        if (this.list) {
            this.init();
        }
    };

    NavInstruction.prototype.getOffset = function () {
        const NAV = this;
        const listHeight = 0
        const headerHeight = itsoftApp.calculations.headerHeight;

        return listHeight + +headerHeight;
    }

    NavInstruction.prototype.getNames = function () {
        const NAV = this;

        for (const link of NAV.links) {
            NAV.data.names.push(link.dataset.href);
        }
    }

    NavInstruction.prototype.setBlocks = function () {
        const NAV = this;

        for (const name of NAV.data.names) {
            NAV.data.blocks.push(document.querySelector(`#${name}`));
        }
    }

    NavInstruction.prototype.isBlockInWindow = function (el) {
        const NAV = this;

        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = top - NAV.getOffset();
        const pointBottom = bottom - NAV.getOffset();

        return pointTop < 1 && pointBottom > 1;
    }

    NavInstruction.prototype.setCurBlock = function () {
        const NAV = this;



        for (let index = 0; index < NAV.data.blocks.length; index++) {
            const block = NAV.data.blocks[index];

            for (const link of NAV.links) {
                link.classList.remove(NAV.data.class.active);
            }

            if (NAV.isBlockInWindow(block)) {
                if (!NAV.links[index].classList.contains(NAV.data.class.active)) {
                    NAV.links[index].classList.add(NAV.data.class.active);
                }
                if (NAV.ul.scrollLeft != NAV.links[index].parentNode.offsetLeft) {
                    NAV.ul.scrollLeft = NAV.links[index].parentNode.offsetLeft;
                }
                break;
            }
        }
    }

    // NavInstruction.prototype.onScroll = function () {
    //     const NAV = this;

    //     NAV.setCurBlock();
    // };


    NavInstruction.prototype.init = function () {
        const NAV = this;

        if (NAV.list) {
            NAV.getNames();
            NAV.setBlocks();
            NAV.setCurBlock();

            const debouncedUpdate = itsoftApp.utils.debouncer(function () {
                NAV.setCurBlock();
            }, 50);

            itsoftApp.modules.pageLoad.addEvent(function () {
                // itsoftApp.modules.windowResize.addEvent(function () {
                //     debouncedUpdate()
                // });
                itsoftApp.modules.windowScroll.addEvent(function () {
                    if (window.innerWidth > 1023) {
                        NAV.setCurBlock();
                    } else {
                        debouncedUpdate()
                    }
                });
            });
        }
    };

    new NavInstruction();
    module.callback = NavInstruction;
});
